module.exports = "/images/bilans.svg?dbca2e0e30beeeb2cb8d7dcc174f1c23";